// export const TopicsCacheKey = {
//   Workspace_Patterns: 'Workspace_Patterns',
//   Workspace_Collections: 'Workspace_Collections',
//   Workspace_Pins: 'Workspace_Pins',

//   Discover_Patterns: 'Discover_Patterns',
//   Discover_Collections: 'Discover_Collections',
//   Discover_Pins: 'Discover_Pins',
// }

export enum TopicsCacheKey {
  Workspace_Patterns = 'Workspace_Patterns',
  Workspace_Collections = 'Workspace_Collections',
  Workspace_Pins = 'Workspace_Pins',

  Discover_Patterns = 'Discover_Patterns',
  Discover_Collections = 'Discover_Collections',
  Discover_Pins = 'Discover_Pins',
}
